import AdminPage from "../pages/admin/page";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RoomsPage from "../pages/rooms/page";
import HotelPage from "../pages/hotel/page";
import AusflugszielePage from "../pages/ausflugsziele/page";
import BuchenPage from "../pages/buchen/page";
import ImpressumPage from "../pages/impressum/page";
import DatenschutzPage from "../pages/datenschutz/page";
import AgbPage from "../pages/agb/page";
import FooterPreviewPage from "../pages/footer-preview/page";
import LagePreviewPage from "../pages/lage-preview/page";
import { PATHS } from "./paths";

// Beide Sprach-Slugs werden auf dieselbe Komponente registriert,
// damit die EN-Variante eigene URLs hat (für SEO + hreflang).
const routes: RouteObject[] = [
  { path: "/admin", element: <AdminPage /> },

  { path: PATHS.home.de,          element: <Home /> },
  { path: PATHS.home.en,          element: <Home /> },
  { path: PATHS.rooms.de,         element: <RoomsPage /> },
  { path: PATHS.rooms.en,         element: <RoomsPage /> },
  { path: PATHS.hotel.de,         element: <HotelPage /> },
  { path: PATHS.hotel.en,         element: <HotelPage /> },
  { path: PATHS.ausflugsziele.de, element: <AusflugszielePage /> },
  { path: PATHS.ausflugsziele.en, element: <AusflugszielePage /> },
  { path: PATHS.buchen.de,        element: <BuchenPage /> },
  { path: PATHS.buchen.en,        element: <BuchenPage /> },
  { path: PATHS.impressum.de,     element: <ImpressumPage /> },
  { path: PATHS.impressum.en,     element: <ImpressumPage /> },
  { path: PATHS.datenschutz.de,   element: <DatenschutzPage /> },
  { path: PATHS.datenschutz.en,   element: <DatenschutzPage /> },
  { path: PATHS.agb.de,           element: <AgbPage /> },
  { path: PATHS.agb.en,           element: <AgbPage /> },

  { path: "/footer-preview", element: <FooterPreviewPage /> },
  { path: "/lage-preview",   element: <LagePreviewPage /> },

  { path: "*", element: <NotFound /> },
];

export default routes;
